<div class="search -results-controls margin-reset-children">
  <h3 [@resultState]="state">
    &#8203; @if (startIndex && endIndex) {
    <span>{{ startIndex }} - {{ endIndex }} of {{ total }}</span>
    }
  </h3>
  <!-- <ul class="search -results-filters -fontSmall">
  <li *ngFor="let filter of filters">
    <button class="search -results-filter -fontSmall"
      [class.is-active]="filter === activeFilter"
    (click)="selectFilter(filter)">{{ filter.label }}</button>
  </li>
</ul> -->
</div>
@if (activeHits.length > 0) {
<div [@resultState]="state">
  @for (result of activeHits; track result) {
  <div class="search -result">
    <!-- <p class="wpdh-type-meta">{{ result._source.type | underscores }}</p> -->
    <h3>{{ result._source.title }}</h3>
    <p class="wpdh-type-grey">
      <small>{{ result._source.route }}</small>
    </p>
    @if (result.highlight && result.highlight.body) {
    <p [innerHTML]="result.highlight.body[0]"></p>
    }
    <a class="search -result-link" [routerLink]="result._source.route" (click)="checkRoute(result._source.route)"></a>
  </div>
  }
</div>
} @else {
<div class="search -no-results">
  @if (start) {
  <p>Start typing to search</p>
  } @if (updating) {
  <div class="wpdh-loader wpdh-search__loader">
    <loader showbackground="false" loadingContent="updating"></loader>
  </div>
  } @if (noResults) {
  <div>
    <p>Sorry! We couldn't find any results for your search!</p>
    <p>Try a less specific search term</p>
  </div>
  }
</div>
} @if (pager && pager.length) {
<div class="search -pager-wrapper">
  <search-pager [pager]="pager" [activePage]="activePage" (onUpdate)="handlePagerUpdate($event)"> </search-pager>
</div>
}
